/**
 * Valid Matrix asset type codes.
 * @readonly
 */
export const MATRIX_TYPE_CODES = [
    "audio_file",
    "bodycopy",
    "bodycopy_container",
    "bodycopy_div",
    "calendar_event",
    "calendar_event_cancellation",
    "calendar_event_modification",
    "calendar_event_multi_date",
    "calendar_event_recurring",
    "calendar_event_single",
    "content_container_template",
    "content_type",
    "content_type_markdown",
    "content_type_nest_content",
    "content_type_raw_html",
    "content_type_snippet",
    "content_type_wysiwyg",
    "css_file",
    "css_file_folder",
    "data_record",
    "data_source",
    "data_source_csv",
    "data_source_db",
    "data_source_ical",
    "data_source_json",
    "data_source_ldap",
    "data_source_record_set",
    "data_source_rss",
    "data_source_soap",
    "data_source_xml",
    "design",
    "design_area",
    "design_css",
    "design_css_customisation",
    "design_customisation",
    "design_scss",
    "editplus_manager",
    "excel_doc",
    "file",
    "file_folder",
    "folder",
    "google_map",
    "image",
    "js_api",
    "js_file",
    "js_file_folder",
    "layout",
    "listing_engine",
    "mirror_config_file",
    "news_item",
    "page",
    "page_asset_listing",
    "page_calendar",
    "page_calendar_events_search",
    "page_calendar_restricted",
    "page_calendar_rolling",
    "page_custom_form",
    "page_custom_form_ecommerce",
    "page_link_manager",
    "page_online_quiz",
    "page_password_reset",
    "page_redirect",
    "page_rest_resource",
    "page_rest_resource_js",
    "page_rest_resource_oauth_session",
    "page_rest_resource_oauth_two_legged",
    "page_rss_feed",
    "page_standard",
    "page_tag_listing",
    "page_upcoming_events_list",
    "page_whats_new",
    "paint_layout_bodycopy",
    "pdf_file",
    "physical_css_file",
    "physical_file",
    "physical_folder",
    "physical_image_file",
    "physical_js_file",
    "powerpoint_doc",
    "rtf_file",
    "search_list",
    "search_page",
    "site",
    "text_file",
    "video_file",
    "word_doc",
    "xml_file",
];

/**
 * Media queries
 * @readonly
 */
export const MEDIA_QUERIES = {
    XSMALL: "screen and (min-width: 0)",
    SMALL: "screen and (min-width: 36rem)",
    MEDIUM: "screen and (min-width: 48rem)",
    LARGE: "screen and (min-width: 62rem)",
    XLARGE: "screen and (min-width: 75rem)",
};
